<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>

    <h3>Checkout</h3>

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Description</th>
          <th scope="col">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in cart">
          <td>{{item.description}}</td>
          <td>${{item.amount}}</td>
        </tr>
        <tr>
          <td>Total:</td>
          <td>${{totalPrice}}</td>
        </tr>
      </tbody>
    </table>
    <div>
      <p>
        <small>
          All fees are non-refundable and credits will not be given.
        </small>
      </p>
      <div class="row" v-if="totalPrice > 0">
        <div class="col">
          <button class="btn btn-primary btn-lg text-center" @click="payByCreditCard">Pay with Credit Card</button>
        </div>
        <div class="col">
          <div class="alert alert-primary">
            If your financial institution requires a Company ID, the NEW Company/Provider ID is 0000408976.
            <i>(The current COMPANY ID may still be used until the change takes place)</i>
          </div>
          <button class="btn btn-primary btn-lg" @click="payByAch">Pay with ACH</button>
        </div>
      </div>
      <div v-else>
        <p>
          Finalize and submit the transaction:
        </p>
        <button class="btn btn-primary" @click="finalize">
          Submit Transaction
        </button>
      </div>
    </div>
    <form ref="lexisNexisForm" method="post" :action="lnLexisNexisPostUrl">
      <input type="hidden" name="ORDER_XML" v-model="orderXml" />
    </form>
  </div>
</template>

<script>
import {
  openBurnChase,
  openBurnLN,
  errorNotification,
  getOpenBurnCart,
  getLNUrl,
  openBurnPaymentus,
} from '~/js/FormFunctions';
import { ShoppingCart } from '~/js/FormObjects';
import Vue from 'vue';

import VueSweetalert2 from 'vue-sweetalert2';

Vue.use(VueSweetalert2);
const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'Checkout',
  data() {
    return {
      fetchingData: false,
      permitId: null,
      orderXml: null,
      sessionId: null,
      cart: null,
      lnReturnUrl: null,
      lnLexisNexisPostUrl: null,
    };
  },
  mounted() {
    const self = this;

    this.permitId = this.$route.query.permitId;

    this.fetchingData = true;
    getOpenBurnCart(this.permitId)
      .then((data) => {
        self.fetchingData = false;
        self.cart = data;
        // self.lnLexisNexisPostUrl = `https://${data.lexisNexisPaymentBaseUrl}/oobML/il/co/cook/DES/`
      })
      .catch(() => {
        self.fetchingData = false;
      });
  },
  methods: {
    payByCreditCard() {
      const self = this;
      this.fetchingData = true;
      const params = {
        applicationNumber: this.permitId,
      };
      openBurnLN(params.applicationNumber)
        .then((data) => {
          getLNUrl()
            .then((result) => {
              self.lnLexisNexisPostUrl = `https://${result}/oobML/il/co/cook/DES/`;

              self.lnReturnUrl = `${window.location.protocol}//${window.location.hostname}`
                + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/#/openburn/thankyou/`;

              const orderXml = `<?xml version="1.0" encoding="utf-8"?>
            <multiLineFormPostRequest>
            <bypassReceiptUrl>${self.lnReturnUrl + data.substring(2)}</bypassReceiptUrl>
            <lexisNexisCode>71527</lexisNexisCode>
            <paymentLineItems>
            <productLines>
            <productAmount>${self.totalPrice}</productAmount>
            <lexisNexisProductCode>DES Online Payment</lexisNexisProductCode>
            <refField>${data}</refField>
            </productLines>
            </paymentLineItems>
            </multiLineFormPostRequest>`;
              self.$set(self, 'orderXml', orderXml);

              self.$nextTick(() => {
                self.$refs.lexisNexisForm.submit();
              });
            });
        })
        .catch((error) => {
          self.fetchingData = false;
          console.error(error);
        });
    },
    payByAch() {
      this.fetchingData = true;
      const self = this;

      openBurnPaymentus(this.permitId);


      // openBurnChase(this.permitId)
      //   .then((response) => {
      //     this.$swal({
      //       title: "ACH Payment Information.",
      //       html: "Your application number: <strong style='font-weight: bold'>" + self.permitId + "</strong> is required during the Chase Payment checkout process. Please note this application number for use at checkout. You will be unable to return to this page once checkout has been initiated.",
      //       type: "info"
      //     }).finally(() => window.location.href = response)
      //   })
      //   .catch((error) => {
      //     self.fetchingData = false
      //     errorNotification('Error submitting payment to vendor:', error)
      //   })
    },
  },
  computed: {
    totalPrice() {
      if (this.cart.length === 0) {
        return 0;
      }
      let amount = 0;
      for (let i = 0; i < this.cart.length; i++) {
        amount += Number(this.cart[i].amount);
      }
      return parseFloat(amount).toFixed(2);
    },
  },
};
</script>
